:host {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
	cursor: pointer;
}
:host smoothly-icon {
	--smoothly-icon-size: 3rem;
	margin-right: 1em;
}
:host:not([open]) smoothly-icon {
	transform: rotate(0deg);
	transition: transform 100ms ease-in-out;
}
:host([open]) smoothly-icon {
	transform: rotate(-90deg);
	transition: transform 100ms ease-in-out;
}
